import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { Link } from '@blaze-cms/nextjs-components';
import { useEcommerceContext } from '@blaze-cms/ecommerce-context';
import { PRODUCT_VARIANTS_ANCHOR_ID, OFFER_PARAM } from '../ProductVariants/constants';
import { getOfferFromPath } from '../ProductVariants/helpers';
import { setQueryParam } from '../helpers/query-params';
import { EVENT_NAMES } from '../../constants';

const buildHref = (url, offer) => {
  const anchor = `#${PRODUCT_VARIANTS_ANCHOR_ID}`;
  if (!url || url === '#') return anchor;
  return `${setQueryParam(url, OFFER_PARAM, offer)}${anchor}`;
};

// With showButtonTextforOffer, the button text is for offer journeys only: it shows when the
// url has an offer and the price shows otherwise. Without it, the button text always
// replaces the price when set.
const shouldShowButtonText = ({ buttonText, offer, showButtonTextforOffer }) =>
  !!buttonText && (!showButtonTextforOffer || !!offer);

const ProductPriceButton = ({
  prefix,
  price,
  buttonText,
  showButtonTextforOffer,
  url,
  selectedVariant,
  parentId
}) => {
  const { emitCartEvent } = useEcommerceContext();
  const { asPath } = useRouter() || {};
  const offer = getOfferFromPath(asPath);
  const showButtonText = shouldShowButtonText({ buttonText, offer, showButtonTextforOffer });

  useEffect(() => {
    if (emitCartEvent) {
      emitCartEvent({
        eventName: EVENT_NAMES.view_item_list,
        input: { selectedVariant, parentId }
      });
    }
  }, []);

  return (
    <Link href={buildHref(url, offer)} className="button button--small">
      {/* The prefix (e.g. "From") belongs to the price, so it's dropped for button text */}
      {showButtonText ? buttonText : `${prefix ? `${prefix} ` : ''}${price}`}
    </Link>
  );
};

ProductPriceButton.propTypes = {
  prefix: PropTypes.string,
  price: PropTypes.string,
  buttonText: PropTypes.string,
  showButtonTextforOffer: PropTypes.bool,
  url: PropTypes.string,
  selectedVariant: PropTypes.object,
  parentId: PropTypes.string
};

ProductPriceButton.defaultProps = {
  prefix: '',
  price: '',
  buttonText: '',
  showButtonTextforOffer: false,
  url: '#',
  selectedVariant: {},
  parentId: ''
};

export default ProductPriceButton;
